import { Controller } from "@hotwired/stimulus"
import AutoNumeric from "autonumeric"

// Controls store fields (price, description, images) visibility based on publicly_bookable.
// Controls default_capacity visibility: only shown when service is NOT individual (grupal).
export default class extends Controller {
  static targets = ["publiclyBookable", "storeFields", "individualService", "defaultCapacityField"]

  connect() {
    this.updateStoreFieldsVisibility()
    this.updateDefaultCapacityFieldVisibility()
  }

  onPubliclyBookableChange() {
    this.updateStoreFieldsVisibility()
  }

  onIndividualServiceChange() {
    this.updateDefaultCapacityFieldVisibility()
  }

  updateStoreFieldsVisibility() {
    if (!this.hasStoreFieldsTarget || !this.hasPubliclyBookableTarget) return

    const yesRadio = this.publiclyBookableTarget.querySelector('input[type="radio"][value="true"]')
    const isChecked = yesRadio?.checked ?? false

    if (isChecked) {
      this.storeFieldsTarget.classList.remove("hidden")
    } else {
      this.storeFieldsTarget.classList.add("hidden")
      const priceInput = this.storeFieldsTarget.querySelector("input[name*='price']")
      if (!priceInput) return

      const autoNumeric = AutoNumeric.getAutoNumericElement(priceInput)
      if (autoNumeric) {
        autoNumeric.clear()
      } else {
        priceInput.value = ""
      }
    }
  }

  updateDefaultCapacityFieldVisibility() {
    if (!this.hasDefaultCapacityFieldTarget) return

    const scope = this.hasIndividualServiceTarget ? this.individualServiceTarget : this.element
    const individualYesRadio = scope.querySelector('input[type="radio"][name*="individual_service"][value="true"]')
    const isIndividual = individualYesRadio?.checked ?? true

    if (isIndividual) {
      this.defaultCapacityFieldTarget.classList.add("hidden")
      const input = this.defaultCapacityFieldTarget.querySelector("input[name*='default_capacity']")
      if (input) input.value = ""
    } else {
      this.defaultCapacityFieldTarget.classList.remove("hidden")
    }
  }
}
